/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addAvailabilityOntologyExportRequest } from '../fn/reporting/add-availability-ontology-export-request';
import { AddAvailabilityOntologyExportRequest$Params } from '../fn/reporting/add-availability-ontology-export-request';
import { addStateOntologyExportRequest } from '../fn/reporting/add-state-ontology-export-request';
import { AddStateOntologyExportRequest$Params } from '../fn/reporting/add-state-ontology-export-request';
import { ExportRequestGenericOntology } from '../models/export-request-generic-ontology';
import { ExportRequestStateOntology } from '../models/export-request-state-ontology';
import { getExportRequestAvailabilityOntology } from '../fn/reporting/get-export-request-availability-ontology';
import { GetExportRequestAvailabilityOntology$Params } from '../fn/reporting/get-export-request-availability-ontology';
import { getExportRequestStateOntology } from '../fn/reporting/get-export-request-state-ontology';
import { GetExportRequestStateOntology$Params } from '../fn/reporting/get-export-request-state-ontology';
import { updateExportRequestAvailabilityOntology } from '../fn/reporting/update-export-request-availability-ontology';
import { UpdateExportRequestAvailabilityOntology$Params } from '../fn/reporting/update-export-request-availability-ontology';
import { updateExportRequestStateOntology } from '../fn/reporting/update-export-request-state-ontology';
import { UpdateExportRequestStateOntology$Params } from '../fn/reporting/update-export-request-state-ontology';


/**
 * All about the REPORTING business
 */
@Injectable({ providedIn: 'root' })
export class ReportingService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addStateOntologyExportRequest()` */
  static readonly AddStateOntologyExportRequestPath = '/custom/export-request/{uid}/ontology/state';

  /**
   * Add a simple state ontology on demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addStateOntologyExportRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addStateOntologyExportRequest$Response(params: AddStateOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestStateOntology>> {
    return addStateOntologyExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a simple state ontology on demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addStateOntologyExportRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addStateOntologyExportRequest(params: AddStateOntologyExportRequest$Params, context?: HttpContext): Observable<ExportRequestStateOntology> {
    return this.addStateOntologyExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestStateOntology>): ExportRequestStateOntology => r.body)
    );
  }

  /** Path part for operation `getExportRequestStateOntology()` */
  static readonly GetExportRequestStateOntologyPath = '/custom/export-request/{uid}/ontology/state/{ontologyUid}';

  /**
   * Get a simple state ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequestStateOntology()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestStateOntology$Response(params: GetExportRequestStateOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestStateOntology>> {
    return getExportRequestStateOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple state ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequestStateOntology$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestStateOntology(params: GetExportRequestStateOntology$Params, context?: HttpContext): Observable<ExportRequestStateOntology> {
    return this.getExportRequestStateOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestStateOntology>): ExportRequestStateOntology => r.body)
    );
  }

  /** Path part for operation `updateExportRequestStateOntology()` */
  static readonly UpdateExportRequestStateOntologyPath = '/custom/export-request/{uid}/ontology/state/{ontologyUid}';

  /**
   * Update a simple state ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportRequestStateOntology()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestStateOntology$Response(params: UpdateExportRequestStateOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateExportRequestStateOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a simple state ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateExportRequestStateOntology$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestStateOntology(params: UpdateExportRequestStateOntology$Params, context?: HttpContext): Observable<void> {
    return this.updateExportRequestStateOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addAvailabilityOntologyExportRequest()` */
  static readonly AddAvailabilityOntologyExportRequestPath = '/custom/export-request/{uid}/ontology/availability';

  /**
   * Add a simple availability ontology on demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addAvailabilityOntologyExportRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addAvailabilityOntologyExportRequest$Response(params: AddAvailabilityOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestGenericOntology>> {
    return addAvailabilityOntologyExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a simple availability ontology on demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addAvailabilityOntologyExportRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addAvailabilityOntologyExportRequest(params: AddAvailabilityOntologyExportRequest$Params, context?: HttpContext): Observable<ExportRequestGenericOntology> {
    return this.addAvailabilityOntologyExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestGenericOntology>): ExportRequestGenericOntology => r.body)
    );
  }

  /** Path part for operation `getExportRequestAvailabilityOntology()` */
  static readonly GetExportRequestAvailabilityOntologyPath = '/custom/export-request/{uid}/ontology/availability/{ontologyUid}';

  /**
   * Get a simple availability ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequestAvailabilityOntology()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestAvailabilityOntology$Response(params: GetExportRequestAvailabilityOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestGenericOntology>> {
    return getExportRequestAvailabilityOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple availability ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequestAvailabilityOntology$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestAvailabilityOntology(params: GetExportRequestAvailabilityOntology$Params, context?: HttpContext): Observable<ExportRequestGenericOntology> {
    return this.getExportRequestAvailabilityOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestGenericOntology>): ExportRequestGenericOntology => r.body)
    );
  }

  /** Path part for operation `updateExportRequestAvailabilityOntology()` */
  static readonly UpdateExportRequestAvailabilityOntologyPath = '/custom/export-request/{uid}/ontology/availability/{ontologyUid}';

  /**
   * Update a simple availability ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportRequestAvailabilityOntology()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestAvailabilityOntology$Response(params: UpdateExportRequestAvailabilityOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateExportRequestAvailabilityOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a simple availability ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateExportRequestAvailabilityOntology$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestAvailabilityOntology(params: UpdateExportRequestAvailabilityOntology$Params, context?: HttpContext): Observable<void> {
    return this.updateExportRequestAvailabilityOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
